import React, { Component } from 'react';

export default class Loading extends Component {
  render() {
    return <h3>Loading...</h3>;
  }
}
